<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },
  props: {
    effect: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="min">
      <PedalKnob
        label="Min"
        tip="Minimum value for the bounce effect."
        :value="effect.min"
        @update:value="v => effect.min = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="max">
      <PedalKnob
        label="Max"
        tip="Maximum value for the bounce effect."
        :value="effect.max"
        @update:value="v => effect.max = v"
        />
    </CcBadge>
  </div>
</template>
